import { render, staticRenderFns } from "./NodeInfoView.vue?vue&type=template&id=0752d451&scoped=true&"
import script from "./NodeInfoView.vue?vue&type=script&lang=js&"
export * from "./NodeInfoView.vue?vue&type=script&lang=js&"
import style0 from "./NodeInfoView.vue?vue&type=style&index=0&id=0752d451&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0752d451",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0752d451')) {
      api.createRecord('0752d451', component.options)
    } else {
      api.reload('0752d451', component.options)
    }
    module.hot.accept("./NodeInfoView.vue?vue&type=template&id=0752d451&scoped=true&", function () {
      api.rerender('0752d451', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InfoView/NodeInfoView.vue"
export default component.exports